import { Component, AfterViewInit, OnInit } from '@angular/core';
import { ROUTES } from './menu-items';
import { RouteInfo } from './sidebar.metadata';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StorageService } from 'src/app/services/storage.service';
import { environment } from 'src/environments/environment';
import { ModuloService } from 'src/app/services/modulos.service';
declare var $: any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {

  showMenu = '';
  showSubMenu = '';

  public sessionInfo: any = {};
  public modulos: any[] = [];
  public usuTsiConfig: any;
  public _base64: any;
  public sidebarnavItems: RouteInfo[] = [];
  public temporalTitulos: RouteInfo[] = [];
  public sidebarnavItems_v2: RouteInfo[] = [];

  // this is for the open close
  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }

  }
  addActiveClass(element: any) {
    if (element === this.showSubMenu) {
      this.showSubMenu = '0';
    } else {
      this.showSubMenu = element;
    }
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  constructor(private ModuloService: ModuloService,
  ) {

    const location = [];
    const myurl = [];

    for (let i = 0; i < ROUTES.length; i++) {
      if (ROUTES[i].submenu.length > 0) {
        location.push(ROUTES[i].title);
        myurl.push(ROUTES[i].url);
      }
    }

    console.log("ROUTES")
    console.log(ROUTES)

  }

  // End open close
  ngOnInit() {
    this.sidebarnavItems_v2 = []
    this.sidebarnavItems = []
    this.temporalTitulos = []

    let _sessionInfo: any = JSON.parse(StorageService.getSession());
    if (_sessionInfo != undefined && _sessionInfo != null) {
      this.sessionInfo = _sessionInfo;
    }
    this.temporalTitulos = ROUTES
    this.sidebarnavItems = this.temporalTitulos
    this.sidebarnavItems.forEach((element: any) => {
      console.log(element)
      if (element.moduloID != null && this.checkModuloID(this.sessionInfo.modulos, element.moduloID)) {
        if (element.title == "Versiones") {
          if (this.sessionInfo.rolId != 3 && this.sessionInfo.rolId != 5 && this.sessionInfo.rolId != 6) {
            return;
          }
        }
        if (element.title == "Licencias") {
          if (this.sessionInfo.rolId != 3 && this.sessionInfo.rolId != 5 && this.sessionInfo.rolId != 6) {
            return;
          }
        }
        element.moduloActive = true;
        this.sidebarnavItems_v2.push(element);
      }
    });
    console.log("this.sidebarnavItems_v2")
    console.log(this.sidebarnavItems_v2)
    console.log('MODULOS',this.sessionInfo.modulos)
    this.ModuloService.obtenerModulos(true).subscribe((resp: any) => {
      this.modulos = Array.isArray(resp.body) ? resp.body : [];
      console.log('MODULOS 22222',this.modulos)

    }, err => {
      console.log(err);
    })
    console.log("StorageService.ID_CIA_ADMIN")
    console.log(StorageService.ID_CIA_ADMIN)
    console.log(this.sessionInfo.id_cia)

    this.sidebarnavItems_v2[1].submenu.forEach((element: any) => {
      console.log(element)
      element.extralink = false;
    });
    this.usuTsiConfig = {
      ruc: '00000000003',
      coduser: this.sessionInfo.coduser,
      clave: this.sessionInfo.clave,
      codsuc: this.sessionInfo.codsuc
    }
    console.log('usuTsiConfig', this.usuTsiConfig)
    this._base64= btoa(JSON.stringify(this.usuTsiConfig));
  }

  private checkModuloID(modulos: any, codmod: number): boolean {
    let vResponse: boolean = false;
    if (modulos != null)
      modulos.forEach((element: any) => {
        if (element.codmod == codmod) {
          vResponse = true;
          return;
        }
      });
    return vResponse;

  }

  checkAccesoID(codmod: number, codacc: number): boolean {
    let vResponse: boolean = false;

    if (this.sessionInfo.accesos != null)
      this.sessionInfo.accesos.forEach((element: any) => {
        if (element.codmod == codmod && (element.codacc == codacc || codacc == 0)) {
          vResponse = true;
          return;
        }
      });
    return vResponse;

  }
  openLink(route: any) {
    switch (route) {
      case "versiones":
        window.open(environment.TSI_VERSIONES + "/" + encodeURIComponent(this._base64))
        break;
      default:

        break;
    }
  }

}
